import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { html as beautifyHtml } from 'js-beautify';

interface UseHtmlFormatterReturn {
  formatHtml: (html: string) => string | null;
  snackbarOpen: boolean;
  snackbarMessage: string;
  snackbarSeverity: 'success' | 'error';
  closeSnackbar: () => void;
}

export const useHtmlFormatter = (): UseHtmlFormatterReturn => {
  const { t } = useTranslation(['templates']);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');

  const formatHtml = useCallback((html: string): string | null => {
    try {
      const formatted = beautifyHtml(html, {
        indent_size: 4,
        indent_char: ' ',
        max_preserve_newlines: 1,
        preserve_newlines: true,
        wrap_line_length: 0,
        end_with_newline: true,
        indent_inner_html: true,
      });
      
      setSnackbarMessage(t('templates:createForm.formatSuccess'));
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      
      return formatted;
    } catch (error) {
      setSnackbarMessage(t('templates:createForm.formatError'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      
      return null;
    }
  }, [t]);

  const closeSnackbar = useCallback(() => {
    setSnackbarOpen(false);
  }, []);

  return {
    formatHtml,
    snackbarOpen,
    snackbarMessage,
    snackbarSeverity,
    closeSnackbar,
  };
};
